import { checkResponse } from "src/components/js/statics1";
import { betoniHash_sliders, keikkaBetoni_hash_attr } from "../betoni/betoniClass";
import { getBetoniRasitusLuokatString } from "../betoni/betoniRasitusluokkaClass";
import changeHandler from "./changeHandler";
import { addStepLogMessage } from "./handleKeikka";
import { keikka_varmenne_save_to_db } from "./KeikkaFunctions";
import {
  asiakas_cacheName,
  keikkaBetoni_cacheName,
  cache_clear,
  keikka_cacheName,
} from "src/components/js/CacheFunctions";
import { betoni_saveRasitusToDB } from "../betoni/BetoniFunctions";
import { socketOnSave } from "../system/socketClass";
import {
  keikkaBetoni_saveComment,
  keikkaBetoni_saveAttrToDB,
} from "../betoni/KeikkaBetoniFunctions";

export default class handleKeikkaChange {
  // static saveStepAikaToDBStatic *add change text from changeHandler, ilmoitukset ei
  // saveStepAikaToDB

  // saveBetoniToimittajaToDB
  // savePumppuToimittajaToDB

  // saveStepPumppuToDB

  // saveKeikkaContactPersonToDB

  // saveStepOsoiteToDB

  // saveAllBetoniChangesToDB
  // saveBetoniCommentToDB
  // saveBetoniRasitusToDB
  // saveBetoniSlidersToDB
  // saveBetoniAttrToDB
  // saveStepM3ToDB

  // TilaChange? tilaClass.saveToDB / .saveKeikkaTilaToDBStatic

  constructor(keikkaData, personId) {
    this.keikkaData = keikkaData;
    this.personId = personId;
    this.keikkaId = keikkaData.keikkaId;
  }

  saveStepAikaToDB = async (origKeikkaData, token, socket) => {
    if (!this.keikkaData.keikkaId) return;

    await saveStepAikaToDBStatic(token, this.keikkaData, this.personId, origKeikkaData, socket);
  };

  /* Osoite */
  saveStepOsoiteToDB = async (keikkaData, token, socket, origKeikkaData, personId) => {
    if (!keikkaData.keikkaId) return;
    cache_clear(keikka_cacheName);
    cache_clear(asiakas_cacheName);
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        keikkaId: keikkaData.keikkaId,
        tyomaaId: keikkaData.tyomaa.tyomaaId,
        asiakasId: keikkaData.asiakas.asiakasId,
        keikkaAjoOhje: keikkaData.tyomaa.keikkaAjoOhje,
        varmenne: keikkaData.varmenne,
        ownerAsiakasId: keikkaData.ownerAsiakasId,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/keikka/tyomaa/set",
      requestOptions
    );
    if (!(await checkResponse(response).success)) return false;

    // send socket event
    const s = new socketOnSave(
      personId,
      socket,
      keikkaData.ownerAsiakasId,
      "keikkaData",
      "save",
      keikkaData.keikkaId
    );
    s.keikkaData = keikkaData;
    s.emitSave();

    if (origKeikkaData) {
      const chObj = new changeHandler(keikkaData, origKeikkaData);
      const chTyomaa = chObj.getTyomaaChange;
      if (chTyomaa.changed) {
        // add stepLog message
        addStepLogMessage(
          keikkaData,
          socket,
          this.personId,
          { title: "Osoitemuutos tilauksessa:" + keikkaData.keikkaId, body: chTyomaa.changeString },
          13,
          true,
          false
        );
        const chAsiakas = chObj.getAsiakasChange;
        if (chAsiakas.changed) {
          // add stepLog message
          addStepLogMessage(
            keikkaData,
            socket,
            this.personId,
            {
              title: "Asiakasmuutos tilauksessa:" + keikkaData.keikkaId,
              body: chAsiakas.changeString,
            },
            13,
            true,
            false
          );
        }
      }
    } else {
      await addStepLogMessage(
        keikkaData,
        socket,
        this.personId,
        "Asiakas/työmaatietoja muutettu",
        13,
        true
      );
    }
  };
  /* Pumppaus */
  saveStepPumppuToDB = async (token, socket, origKeikkaData, personId) => {
    if (!this.keikkaData.keikkaId) return;
    cache_clear(keikka_cacheName);
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        keikkaId: this.keikkaData.keikkaId,
        pumppuPuomi: this.keikkaData.pumppu.pumppuPuomi,
        pumppuLinja: this.keikkaData.pumppu.pumppuLinja,
        varmenne: this.keikkaData.varmenne,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/keikka/pumppu/setPuomiLinja",
      requestOptions
    );
    if (!(await checkResponse(response).success)) return false;

    // send socket event
    const s = new socketOnSave(
      personId,
      socket,
      this.keikkaData.ownerAsiakasId,
      "keikkaData",
      "save",
      this.keikkaData.keikkaId
    );
    s.keikkaData = this.keikkaData;
    s.emitSave();

    if (origKeikkaData) {
      const chObj = new changeHandler(this.keikkaData, origKeikkaData);
      const chObject = chObj.getPuomiLinjaChange;
      if (chObject.changed) {
        addStepLogMessage(
          this.keikkaData,
          socket,
          this.personId,
          {
            title: "Pumppumuutos tilauksessa:" + this.keikkaData.keikkaId,
            body: chObject.changeString,
          },
          13,
          true
        );
      }
    }
    return;
  };

  /* Betoni */

  saveBetoniSlidersToDB = async (betoni, token, socket) => {
    if (!this.keikkaData.keikkaId) return;
    cache_clear(keikkaBetoni_cacheName);
    const keikkaBetoniId = betoni.keikkaBetoniId;
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        keikkaBetoniId: keikkaBetoniId,
        laatuId: betoni.laatu.laatuId,
        isNopea: betoni.isNopea,
        raeKokoId: betoni.raeKoko.raeKokoId,
        lujuusId: betoni.lujuus.lujuusId,
        notkeusId: betoni.notkeus.notkeusId,
        raeKokoText: betoni.raeKoko.raeKokoText,
        lujuusText: betoni.lujuus.lujuusText,
        notkeusText: betoni.notkeus.notkeusText,
        kayttoIkaId: betoni.kayttoIka.kayttoIkaId,
        varmenne: this.keikkaData.varmenne,
        keikkaId: this.keikkaData.keikkaId,
        commonHash: betoni.commonHash,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/keikka/betoni/setSliders",
      requestOptions
    ).catch((error) => console.log(error));
    if (!(await checkResponse(response).success)) return false;

    // send socket event
    const s = new socketOnSave(
      socket,
      this.keikkaData.ownerAsiakasId,
      "keikkaData",
      "save",
      this.keikkaData.keikkaId
    );
    s.keikkaData = this.keikkaData;
    s.comment = "Betonin laatu muutettu";
    s.function = "saveBetoniSlidersToDB";
    s.emitSave();

    return;
  };

  saveStepM3ToDB = async (
    betoni,
    token,
    emitSocket = true,
    addStepLog = true,
    origM3 = null,
    socket,
    personId
  ) => {
    if (!this.keikkaData.keikkaId) return;
    cache_clear(keikkaBetoni_cacheName);
    const keikkaBetoniId = betoni.keikkaBetoniId;
    const m3 = betoni.m3;

    if (!keikkaBetoniId) return null;
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        keikkaBetoniId: keikkaBetoniId,
        m3: m3,
        keikkaId: this.keikkaData.keikkaId,
        varmenne: this.keikkaData.varmenne,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/keikka/betoni/setM3",
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          throw Error("Save failed");
        }
        this.originalM3Hash = this.m3Hash;
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((error) => {
        throw Error(error);
      });

    // send socket event
    if (emitSocket) {
      const s = new socketOnSave(
        personId,
        socket,
        this.keikkaData.ownerAsiakasId,
        "keikkaData",
        "save",
        this.keikkaData.keikkaId
      );
      s.keikkaData = this.keikkaData;
      s.comment = "Betonin m3 muutettu";
      s.function = "saveStepM3ToDB";
      s.emitSave();
    }
    addStepLog &&
      origM3 != null &&
      betoni.m3 != origM3 &&
      addStepLogMessage(
        this.keikkaData,
        socket,
        this.personId,
        {
          title: "M3 muutettu tilauksessa:" + this.keikkaData.keikkaId,
          body: "M3 muutettu: " + origM3 + "m3 -> " + betoni.m3 + "m3",
        },
        13,
        true
      );
    return response;
  };

  saveAllBetoniChangesToDB = async (betoni, origBetoni, token, socket, personId) => {
    let changeString = "";
    cache_clear(keikkaBetoni_cacheName);

    if (!this.keikkaData.keikkaId) return;
    if (betoni.betoniComment != origBetoni.betoniComment) {
      //console.log("SAVE BETONI COMMENT");
      changeString += "Betonikommentti muutettu. \n";
      await keikkaBetoni_saveComment(betoni, token);
    }

    //if (keikkaBetoni_rasitus_hash(betoni) != keikkaBetoni_rasitus_hash(origBetoni)) {
    if (betoni.rasitus.hash != origBetoni.rasitus.hash) {
      const a = getBetoniRasitusLuokatString(origBetoni.rasitus.rasitusluokat);
      const b = getBetoniRasitusLuokatString(betoni.rasitus.rasitusluokat);
      if (a != b) {
        changeString += "Rasitusluokkia muutettu. " + a + " -> " + b + " \n";
        await this.saveBetoniRasitusToDB(betoni, token);
      }
    }

    if (keikkaBetoni_hash_attr(betoni) != keikkaBetoni_hash_attr(origBetoni)) {
      changeString += "Betonilisiä muutettu. \n";
      //console.log("SAVE BETONI ATTR");
      await keikkaBetoni_saveAttrToDB(betoni, token);
    }

    const a = betoniHash_sliders(betoni);
    const b = betoniHash_sliders(origBetoni);
    if (a != b) {
      changeString += "Betonin laatua muutettu. \n";
      //console.log("SAVE BETONI SLIDERS");
      await this.saveBetoniSlidersToDB(betoni, token, null);
    }
    if (changeString.length > 0) {
      await addStepLogMessage(
        this.keikkaData,
        socket,
        this.personId,
        {
          title: "Betonimuutos tilauksessa:" + this.keikkaData.keikkaId,
          body: changeString,
        },
        13,
        true
      );
      // send socket event
      const s = new socketOnSave(
        personId,
        socket,
        this.keikkaData.ownerAsiakasId,
        "keikkaData",
        "save",
        this.keikkaData.keikkaId
      );
      s.keikkaData = this.keikkaData;
      s.comment = "Betonin muutoksia tallennettu";
      s.function = "saveAllBetoniChangesToDB";
      s.emitSave();
    }
  };

  saveBetoniRasitusToDB = async (betoni, token) => {
    if (!this.keikkaData.keikkaId) return;
    cache_clear(keikkaBetoni_cacheName);

    await betoni_saveRasitusToDB(betoni, token, this.keikkaData.varmenne, this.keikkaData.keikkaId);
  };

  /* Pumppu- ja betonitoimijat sekä laskutus */
  saveBetoniToimittajaToDB = async (
    keikkaId,
    asiakasId,
    sijaintiId,
    matkaM,
    matkaAika,
    token,
    socket,
    isChanged = true,
    personId = null
  ) => {
    if (keikkaId === 0) return;
    if (asiakasId === 0) return;
    if (sijaintiId === 0) {
      console.log("NOT SAVED, sijaintiId = 0");
      return;
    }
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        keikkaId: keikkaId,
        betoniAsiakasId: asiakasId,
        betoniSijaintiId: sijaintiId,
        matkaM: matkaM,
        matkaAika: matkaAika,
        varmenne: this.keikkaData.varmenne,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/keikka/betonitoimittaja/set",
      requestOptions
    );
    if (!response.ok) return false;

    // send socket event
    const s = new socketOnSave(
      personId,
      socket,
      this.keikkaData.ownerAsiakasId,
      "keikkaData",
      "save",
      this.keikkaData.keikkaId
    );
    s.keikkaData = this.keikkaData;
    s.comment = "Betonivalmistaja tallennettu";
    s.function = "saveBetoniToimittajaToDB";
    s.emitSave();

    if (isChanged)
      addStepLogMessage(
        this.keikkaData,
        socket,
        this.personId,
        "Betonivalmistaja tallennettu",
        13,
        true
      );
    return true;
  };

  savePumppuToimittajaToDB = async (
    keikkaId,
    asiakasId,
    sijaintiId,
    matkaM,
    matkaAika,
    token,
    socket,
    isChanged = true,
    personId = null
  ) => {
    if (keikkaId === 0) return;
    if (asiakasId === 0) return;
    if (sijaintiId === 0) return;
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        keikkaId: keikkaId,
        pumppuAsiakasId: asiakasId,
        pumppuSijaintiId: sijaintiId,
        matkaM: matkaM,
        matkaAika: matkaAika,
        varmenne: this.keikkaData.varmenne,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/keikka/pumpputoimittaja/set",
      requestOptions
    ).catch((error) => console.log(error));
    if (!response.ok) return false;

    // send socket event TODO:personId
    const s = new socketOnSave(personId, socket, null, "keikkaData", "save", this.keikkaId);
    s.keikkaData = this.keikkaData;
    s.comment = "Pumpputoimittaja tallennettu";
    s.function = "savePumppuToimittajaToDB";
    s.emitSave();

    if (isChanged)
      addStepLogMessage(
        this.keikkaData,
        socket,
        this.personId,
        "Pumpputoimittaja tallennettu",
        13,
        true
      );
  };
  saveLaskutusToDB = async (keikkaData, token, socket) => {
    //todo
    if (!keikkaData.keikkaId) return;
    const a = await keikkaData.laskutus.saveLaskutusToDB(
      keikkaData.keikkaId,
      token,
      socket,
      keikkaData.varmenne
    );
    addStepLogMessage(this.keikkaData, socket, this.personId, "Laskutusketjua muutettu", 13, true);
    return a;
  };

  /* Undo actions */
  undoStepAika = (keikkaData, origKeikkaData) => {
    if (
      JSON.stringify(keikkaData.pumppu.pumppuAika) !=
      JSON.stringify(origKeikkaData.pumppu.pumppuAika)
    ) {
      //console.log("Pumppu aika changed");
      return -1;
    }
    if (keikkaData.pumppu.pumppuKesto !== origKeikkaData.pumppu.pumppuKesto) {
      keikkaData.pumppu.pumppuKesto = origKeikkaData.pumppu.pumppuKesto;
    }
    return 1;
  };
  undoStepPumppu = (keikkaData, origKeikkaData) => {
    keikkaData.pumppu.pumppuPuomi = origKeikkaData.pumppu.pumppuPuomi;
    keikkaData.pumppu.pumppuLinja = origKeikkaData.pumppu.pumppuLinja;
    return 2;
  };

  undoStepM3 = (keikkaData, origKeikkaData, keikkaBetoniId) => {
    const betoni = keikkaData.betoni.find((b) => b.keikkaBetoniId === keikkaBetoniId);
    const origBetoni = origKeikkaData.betoni.find((b) => b.keikkaBetoniId === keikkaBetoniId);
    betoni.m3 = origBetoni.m3;
    return 1;
  };
}

/* Aika */
export async function saveStepAikaToDBStatic(token, keikkaData, personId, origKeikkaData, socket) {
  if (!keikkaData.keikkaId) return;
  cache_clear(keikka_cacheName);
  const keikkaId = keikkaData.keikkaId;
  const pumppuAika = keikkaData.pumppu.pumppuAika;
  const betoniAika = keikkaData.pumppu.betoniAika;
  const tyhjänäTyömaalle = keikkaData.pumppu.tyhjänäTyömaalle;
  const pumppuKesto = keikkaData.pumppu.pumppuKesto;
  const kellonAikaTxt = keikkaData.pumppu.kellonAikaTxt;
  // save to sql
  await saveStepAikaToDBStaticOnlyAPI(
    token,
    socket,
    keikkaId,
    pumppuAika,
    pumppuKesto,
    keikkaData.varmenne,
    kellonAikaTxt,
    keikkaData.pumppu.ehdotaAikaa,
    betoniAika,
    tyhjänäTyömaalle
  );
  if (
    origKeikkaData.pumppu.pumppuAika !== pumppuAika ||
    origKeikkaData.pumppu.pumppuKesto !== pumppuKesto
  ) {
    const chClass = new changeHandler(keikkaData, origKeikkaData);
    const chObject = chClass.getAikaKestoChange;
    if (chObject.changed) {
      // add stepLog message
      addStepLogMessage(
        keikkaData,
        socket,
        personId,
        { title: "Aikamuutos tilaksessa:" + keikkaData.keikkaId, body: chObject.changeString },
        13,
        true,
        false
      );
    }
  }
}
export async function saveStepAikaToDBStaticOnlyAPI(
  token,
  socket,
  keikkaId,
  pumppuAika,
  pumppuKesto,
  varmenne,
  kellonAikaTxt = "",
  ehdotaAikaa = false,
  betoniAika = null,
  tyhjänäTyömaalle = null,
  personId = null,
  keikkaData = null,
  gridKeikka = null
) {
  cache_clear(keikka_cacheName);
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      keikkaId: keikkaId,
      pumppuAika: pumppuAika,
      pumppuKesto: pumppuKesto,
      varmenne: varmenne,
      kellonAikaTxt: kellonAikaTxt,
      ehdotaAikaa: ehdotaAikaa,
      betoniAika: betoniAika,
      tyhjänäTyömaalle: tyhjänäTyömaalle,
    }),
  };

  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/keikka/pumppu/setAika",
    requestOptions
  ).catch((error) => console.log(error));
  if (!(await checkResponse(response).success)) return false;

  // send socket event TODO:personId TODO:personId, keikkaData, gridKeikka
  const s = new socketOnSave(
    personId,
    socket,
    null,
    keikkaData !== null ? "keikkaData" : "gridKeikka",
    "save",
    keikkaId
  );
  s.keikkaData = keikkaData;
  s.gridKeikka = gridKeikka;
  s.comment = "Aikamuutos tallennettu";
  s.function = "saveStepAikaToDBStatic";
  s.emitSave();
}

/* Yhteys */
export async function saveKeikkaContactPersonToDB(keikkaData, token, personId, socket) {
  if (!keikkaData.keikkaId) return;
  await keikkaData.saveKeikkaMainPersonPersonToDB(token, socket);
  keikka_varmenne_save_to_db(keikkaData.keikkaId, keikkaData.varmenne, token);
  await addStepLogMessage(
    keikkaData,
    socket,
    personId,
    "Tilauksen vastuuhenkilö muutettu",
    13,
    true
  );
}
